import * as Styled from './single-select.styles';
import type { SingleSelectProps } from './single-select.types';

export const SingleSelect = ({
  children,
  selected,
  ...props
}: SingleSelectProps): JSX.Element => (
  <Styled.SingleSelect data-xds="SingleSelect" $selected={selected} {...props}>
    {children}
  </Styled.SingleSelect>
);
